export const tenantIdStorageKey = "tenant_id";

export const tenantIdStorage = {
  update(tenantId: string) {
    localStorage.setItem(tenantIdStorageKey, tenantId);
  },
  get() {
    return localStorage.getItem(tenantIdStorageKey);
  },
  remove() {
    localStorage.removeItem(tenantIdStorageKey);
  },
};
